interface SourceOfFund {
  code: string;
  isAccepted: boolean;
}

interface Requester {
  id: string;
  tid: string;
  address1: string;
  address2: string;
  city: string;
  province: string;
  zipcode: string;
  country: string;
  sourceOfFunds: SourceOfFund[];
  createdAt: string;
  updatedAt: string;
  updatedBy: string;
}

export interface SessionMid {
  email: string;
  merchantID: string;
  mid: string;
  role: string;
  createdAt: string;
  invitedAt: string;
  status: string;
  merchantName: string;
  requesters: Requester[];
  permissions: string[] | null;
  visible_biller_request: boolean;
  visible_payment_request: boolean;
  is_recurring_merchant: boolean;
  enrollment_type: boolean;
}

export interface SetSession {
  users: SessionMid[];
}

export type Session = Omit<SetSession, 'users'>;

export function setSession(session: SetSession): void {
  clearSession();
  localStorage.setItem('users', JSON.stringify(session.users));
  const expDate = new Date();
  expDate.setDate(expDate.getDate() + 3);
  localStorage.setItem('expDate', expDate.toISOString());
}

export function setUserIndex(userIndex: number): void {
  localStorage.setItem('userIndex', userIndex.toString());
}

export function getCurrentUser(): SessionMid | undefined | null {
  if (!isExpired()) {
    const users = getUsers() || [];
    const userIndex = localStorage.getItem('userIndex');
    return users[JSON.parse(userIndex)];
  }
  return null;
}

export function getUsers(): SessionMid[] | null {
  if (!isExpired()) {
    const users = localStorage.getItem('users');
    return JSON.parse(users);
  }
  return null;
}

export function isExpired(): boolean {
  const now = new Date();
  const expDate = new Date(localStorage.getItem('expDate'));
  return now.getTime() > expDate.getTime();
}

export function clearSession(): void {
  localStorage.clear();
}
